import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MakePayment from "./makePayment";
import { addPayment } from "services/redux/brandActivtion/Invoice/action";

const mapStateToProps = (state) => ({
 
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      addPayment
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MakePayment);
